type Props = {
  currentStep: number;
  totalSteps: number;
  title: string;
};

export const StepHeader = ({ currentStep, totalSteps, title }: Props) => {
  return (
    <div className="mb-4">
      <span className="typography-body-sm text-monochrome-900 mb-2 block">
        Step {currentStep} of {totalSteps}
      </span>
      <h3>{title}</h3>
    </div>
  );
};
